import {
  Directive,
  HostListener,
  Input,
} from '@angular/core';
import {NgbTypeahead} from "@ng-bootstrap/ng-bootstrap";
import {merge, Observable, Subject} from "rxjs";
import {debounceTime, distinctUntilChanged, map} from "rxjs/operators";

@Directive({
  selector: '[vssUiAutoCplControl][vssUiAutocomplete]',
  // exportAs: 'csAutocomplete'
})
export class CsAutocompleteDirective extends NgbTypeahead {
  KEY_AUTO_COMPLETE_STORE = 'auto_complete'
  MAX_VALUES = 5
  @Input() disabledAutoComplete:boolean = false
  @Input() vssUiAutocomplete:string = ''
  @Input() container = 'body'
  @Input() focusFirst = false
  focus$ = new Subject<string>();
  ngbTypeahead = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const inputFocus$ = this.focus$;
    return merge(debouncedText$, inputFocus$).pipe(
      map(
        (term) => {
          const localStore = localStorage.getItem(this.keyAutoCompleteStore)
          let states: any[] = []
          if(localStore) {
            try {
              states = JSON.parse(localStore)
            } catch {}
          }
          return this.disabledAutoComplete ? [] : states.filter((v) => v.toLowerCase().includes(term.toLowerCase()))
        }
      ),
    );
  }

  get keyAutoCompleteStore() {
    return this.KEY_AUTO_COMPLETE_STORE + '_' + (this.vssUiAutocomplete || 'default')
  }
  @HostListener('focus', ['$event']) onFocus(event: any) {
    const inputTarget = event.target
    this.focus$.next(inputTarget.value)
  }

  @HostListener('click', ['$event']) onClick(event: any) {
    const inputTarget = event.target
    this.focus$.next(inputTarget.value)
  }

  @HostListener('blur', ['$event']) onBlur(event: any) {
    const inputTarget = event.target
    const value = inputTarget?.value ? `${inputTarget?.value}`.trim() : ''
    if(value?.length > 2) {
      const localStore = localStorage.getItem(this.keyAutoCompleteStore)
      let states: any[] = []
      if(localStore) {
        try {
          states = JSON.parse(localStore)
        } catch {}
      }
      if(states.length >= this.MAX_VALUES) {
        states = states.slice(0, this.MAX_VALUES - 1)
      }
      if(states.some(s => s.toLowerCase() == value?.toLowerCase())) {
        states.splice(states.findIndex(s => s.toLowerCase() == value?.toLowerCase()), 1)
      }
      states = [value].concat(states)
      localStorage.setItem(this.keyAutoCompleteStore, JSON.stringify(states))
    }
  }
}
